import {
  createRootRoute, createRoute, createRouter, Outlet,
} from '@tanstack/react-router';
import { AppShell } from '../components/layout/AppShell.js';
import { DashboardPage } from '../features/dashboard/DashboardPage.js';
import { TenantsPage } from '../features/tenants/TenantsPage.js';
import { ExtensionsPage } from '../features/extensions/ExtensionsPage.js';
import { CdrsPage } from '../features/cdrs/CdrsPage.js';
import { CarriersPage } from '../features/carriers/CarriersPage.js';
import { BillingPage } from '../features/billing/BillingPage.js';
import { PlaceholderPage } from '../features/misc/PlaceholderPage.js';

const rootRoute = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});

const route = (path: string, component: () => JSX.Element) =>
  createRoute({ getParentRoute: () => rootRoute, path, component });

const routeTree = rootRoute.addChildren([
  route('/', DashboardPage),
  route('/tenants', TenantsPage),
  route('/extensions', ExtensionsPage),
  route('/calls', CdrsPage),
  route('/numbers', () => <PlaceholderPage title="Numbers" phase="Phase 2" />),
  route('/flows', () => <PlaceholderPage title="Call flows" phase="Phase 2" />),
  route('/queues', () => <PlaceholderPage title="Queues" phase="Phase 3" />),
  route('/carriers', CarriersPage),
  route('/nodes', () => <PlaceholderPage title="Nodes & fleet" phase="Phase 2" />),
  route('/billing', BillingPage),
  route('/settings', () => <PlaceholderPage title="Settings" phase="Phase 2" />),
]);

export const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}
